import React from 'react'
import cn from 'clsx'
import s from './styles.module.scss'

export type ImpactLevel = 'low' | 'medium' | 'high' | 'none'

const LEVEL_TO_ACTIVE = {
  none: 0,
  low: 1,
  medium: 2,
  high: 3,
} as const

export const ImpactIndicator: React.FC<{
  level: ImpactLevel
  className?: string
}> = ({ level, className }) => {
  const active = LEVEL_TO_ACTIVE[level]

  return (
    <div className={cn(s.root, className)} aria-label={`Impact: ${level}`}>
      {Array.from({ length: 3 }).map((_, i) => (
        <span key={i} className={cn(s.dot, i < active && s.active)} />
      ))}
    </div>
  )
}
